module.exports = __webpack_public_path__ + "static/media/blank_copy.30ef58c3.pdf";